import React, {
  useState,
  useEffect,
  useReducer,
  useContext,
  useRef,
} from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import { Facebook, Instagram, WhatsApp, Person } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import DeleteSweepIcon from "@material-ui/icons/DeleteSweep";

import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";

import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import BlockIcon from "@material-ui/icons/Block";

import Checkbox from "@material-ui/core/Checkbox";

import api from "../../services/api";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import ContactModal from "../../components/ContactModal";
import ConfirmationModal from "../../components/ConfirmationModal";

import { i18n } from "../../translate/i18n";
import MainContainer from "../../components/MainContainer";
import toastError from "../../errors/toastError";

import { AuthContext } from "../../context/Auth/AuthContext";
import { Can } from "../../components/Can";
import NewTicketModal from "../../components/NewTicketModal";
import { TagsFilter } from "../../components/TagsFilter";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import formatSerializedId from "../../utils/formatSerializedId";
import { v4 as uuidv4 } from "uuid";

import {
  ArrowDropDown,
  Backup,
  ContactPhone,
} from "@material-ui/icons";
import { Menu, MenuItem } from "@material-ui/core";

import ContactImportWpModal from "../../components/ContactImportWpModal";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const reducer = (state, action) => {
  if (action.type === "LOAD_CONTACTS") {
    const contacts = action.payload;
    const newContacts = [];

    contacts.forEach((contact) => {
      const contactIndex = state.findIndex((c) => c.id === contact.id);
      if (contactIndex !== -1) {
        state[contactIndex] = contact;
      } else {
        newContacts.push(contact);
      }
    });

    return [...state, ...newContacts];
  }

  if (action.type === "UPDATE_CONTACTS") {
    const contact = action.payload;
    const contactIndex = state.findIndex((c) => c.id === contact.id);

    if (contactIndex !== -1) {
      state[contactIndex] = contact;
      return [...state];
    }
    return [contact, ...state];
  }

  if (action.type === "DELETE_CONTACT") {
    const contactId = action.payload;

    const contactIndex = state.findIndex((c) => c.id === contactId);
    if (contactIndex !== -1) {
      state.splice(contactIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    minHeight: 0,
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    minHeight: 0,
    height: "100%",
    overflowY: "auto",
    overflowX: "hidden",
    paddingRight: 6,
    ...theme.scrollbarStyles,
  },
  heroCard: {
    borderRadius: 22,
    padding: theme.spacing(2.5),
    flexShrink: 0,
    border: "1px solid rgba(32, 77, 187, 0.08)",
    boxShadow: "0 16px 45px rgba(15, 23, 42, 0.06)",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
  },
  heroTop: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  titleBlock: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.75),
  },
  pageTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    flexWrap: "wrap",
  },
  pageTitle: {
    fontWeight: 800,
    color: "#132a56",
    letterSpacing: "-0.02em",
  },
  pageSubtitle: {
    color: "#6b7a99",
    fontWeight: 500,
  },
  countBadge: {
    height: 38,
    borderRadius: 999,
    fontWeight: 700,
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    backgroundColor: "#eef4ff",
    color: "#245bdb",
    border: "1px solid #d6e4ff",
  },
  heroStats: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(140px, 1fr))",
    gap: theme.spacing(1.5),
    width: "100%",
    maxWidth: 500,
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
      maxWidth: "100%",
    },
  },
  statCard: {
    borderRadius: 18,
    padding: theme.spacing(1.75, 2),
    background: "#fff",
    border: "1px solid #edf1f7",
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.04)",
  },
  statLabel: {
    color: "#7c8aa5",
    fontSize: 12,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: ".04em",
    marginBottom: theme.spacing(0.75),
  },
  statValue: {
    color: "#14213d",
    fontWeight: 800,
  },
  filtersCard: {
    borderRadius: 20,
    padding: theme.spacing(1.5, 2),
    flexShrink: 0,
    border: "1px solid rgba(32, 77, 187, 0.08)",
    boxShadow: "0 16px 45px rgba(15, 23, 42, 0.05)",
    backgroundColor: "#ffffff",
  },
  filtersGrid: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.25),
    flexWrap: "wrap",
    '& > *': {
      minWidth: 0,
    },
  },
  searchWrapper: {
    flex: "1 1 230px",
    maxWidth: 350,
    [theme.breakpoints.down("sm")]: { maxWidth: "100%" },
  },
  searchField: {
    backgroundColor: "#f8fbff",
    borderRadius: 12,
    '& .MuiOutlinedInput-root': {
      borderRadius: 12,
      height: 42,
      backgroundColor: "#f8fbff",
    },
  },
  tagsWrapper: {
    flex: "0 1 210px",
    minWidth: 175,
    backgroundColor: "#f8fbff",
    borderRadius: 12,
    border: "1px solid rgba(35, 92, 223, 0.12)",
    minHeight: 42,
    display: "flex",
    alignItems: "center",
    '& > div': {
      width: "100%",
    },
    '& > div > div': {
      padding: 0,
    },
    '& .MuiAutocomplete-root': {
      width: "100%",
    },
    '& .MuiOutlinedInput-root': {
      minHeight: 40,
      paddingTop: "2px !important",
      paddingBottom: "2px !important",
    },
    [theme.breakpoints.down("sm")]: {
      flex: "1 1 180px",
    },
  },
  actionsRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    flexWrap: "wrap",
  },
  actionsLeft: {
    display: "flex",
    gap: theme.spacing(1),
    flexWrap: "wrap",
  },
  roundedButton: {
    borderRadius: 12,
    textTransform: "none",
    fontWeight: 700,
    minHeight: 42,
    padding: theme.spacing(0.75, 1.5),
    boxShadow: "none",
  },
  addButton: {
    background: "linear-gradient(135deg, #1f67ff 0%, #245bdb 100%)",
    color: "#fff",
    '&:hover': {
      background: "linear-gradient(135deg, #1659e9 0%, #1f53c9 100%)",
      boxShadow: "0 10px 20px rgba(36, 91, 219, 0.18)",
    },
  },
  secondaryButton: {
    backgroundColor: "#f4f8ff",
    color: "#245bdb",
    border: "1px solid #dbe6ff",
    '&:hover': {
      backgroundColor: "#eaf2ff",
      boxShadow: "none",
    },
  },
  deleteButton: {
    backgroundColor: "#f7f8fa",
    color: "#97a1b2",
    border: "1px solid #eceff4",
    '&:hover': {
      backgroundColor: "#f0f3f8",
      boxShadow: "none",
    },
  },
  deleteSelectedActive: {
    color: "#bf3144",
    backgroundColor: "#fff0f2",
    border: "1px solid #ffd5dc",
    '&:hover': { backgroundColor: "#ffe6ec" },
  },
  selectedInfo: {
    color: "#6b7a99",
    fontWeight: 700,
    whiteSpace: "nowrap",
  },
  tablePaper: {
    flexShrink: 0,
    minHeight: 0,
    overflow: "visible",
    borderRadius: 22,
    border: "1px solid rgba(32, 77, 187, 0.08)",
    boxShadow: "0 18px 48px rgba(15, 23, 42, 0.06)",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fff",
  },
  tableHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2, 2.5),
    borderBottom: "1px solid #edf2f8",
    gap: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  tableTitle: {
    fontWeight: 800,
    color: "#132a56",
  },
  tableSubTitle: {
    color: "#7c8aa5",
    fontWeight: 500,
  },
  tableScroller: {
    overflowX: "auto",
    overflowY: "visible",
    ...theme.scrollbarStyles,
  },
  tableRoot: {
    minWidth: 980,
  },
  headerCell: {
    fontSize: 12,
    fontWeight: 800,
    color: "#70809d",
    textTransform: "uppercase",
    letterSpacing: ".05em",
    backgroundColor: "#f8fbff",
    borderBottom: "1px solid #edf2f8",
    paddingTop: theme.spacing(1.6),
    paddingBottom: theme.spacing(1.6),
  },
  row: {
    transition: "background-color .2s ease, transform .2s ease",
    '&:hover': {
      backgroundColor: "#f9fbff",
    },
    '& td': {
      borderBottom: "1px solid #eef2f7",
    },
  },
  contactCell: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    minWidth: 220,
  },
  avatar: {
    width: 44,
    height: 44,
    borderRadius: "50%",
    backgroundColor: "#eef2f7",
    color: "#94a3b8",
    fontWeight: 700,
    flexShrink: 0,
    '& img': {
      objectFit: "cover",
    },
  },
  contactInfo: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
  },
  contactName: {
    fontWeight: 700,
    color: "#162544",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  contactMeta: {
    color: "#7f8ca6",
    fontSize: 12,
  },
  statusChip: {
    borderRadius: 999,
    fontWeight: 700,
    height: 32,
  },
  statusActive: {
    backgroundColor: "#eaf8ef",
    color: "#18864b",
  },
  statusInactive: {
    backgroundColor: "#fff1f1",
    color: "#cf3d3d",
  },
  channelChip: {
    borderRadius: 12,
    fontWeight: 700,
    height: 28,
    backgroundColor: "#eef4ff",
    color: "#245bdb",
  },
  actionsCell: {
    whiteSpace: "nowrap",
  },
  iconButton: {
    marginRight: theme.spacing(0.5),
    backgroundColor: "#f7f9fc",
    border: "1px solid #edf2f8",
    '&:hover': {
      backgroundColor: "#eef4ff",
    },
  },
  mutedText: {
    color: "#8d97aa",
  },
}));

const Contacts = () => {
  const classes = useStyles();
  const history = useHistory();

  const { user, socket } = useContext(AuthContext);
  const { setCurrentTicket } = useContext(TicketsContext);

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchParam, setSearchParam] = useState("");
  const [contacts, dispatch] = useReducer(reducer, []);
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [contactModalOpen, setContactModalOpen] = useState(false);

  const [importContactModalOpen, setImportContactModalOpen] = useState(false);
  const [deletingContact, setDeletingContact] = useState(null);
  const [ImportContacts, setImportContacts] = useState(null);
  const [blockingContact, setBlockingContact] = useState(null);
  const [unBlockingContact, setUnBlockingContact] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [exportContact, setExportContact] = useState(false);
  const [confirmChatsOpen, setConfirmChatsOpen] = useState(false);

  const [hasMore, setHasMore] = useState(false);
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [contactTicket, setContactTicket] = useState({});

  const fileUploadRef = useRef(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const [hideNum, setHideNum] = useState(false);
  const [enableLGPD, setEnableLGPD] = useState(false);

  const [selectedContactsIds, setSelectedContactsIds] = useState(new Set());
  const [confirmDeleteSelectedOpen, setConfirmDeleteSelectedOpen] = useState(false);

  const { getAll: getAllSettings } = useCompanySettings();

  useEffect(() => {
    async function fetchData() {
      const settingList = await getAllSettings(user.companyId);

      for (const [key, value] of Object.entries(settingList)) {
        if (key === "enableLGPD") setEnableLGPD(value === "enabled");
        if (key === "lgpdHideNumber") setHideNum(value === "enabled");
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleImportExcel = async () => {
    try {
      const formData = new FormData();
      formData.append("file", fileUploadRef.current.files[0]);
      await api.request({
        url: `/contacts/upload`,
        method: "POST",
        data: formData,
      });
      history.go(0);
    } catch (err) {
      toastError(err);
    }
  };

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam, selectedTags]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          const { data } = await api.get("/contacts/", {
            params: { searchParam, pageNumber, contactTag: JSON.stringify(selectedTags) },
          });
          dispatch({ type: "LOAD_CONTACTS", payload: data.contacts });
          setHasMore(data.hasMore);
          setLoading(false);
        } catch (err) {
          toastError(err);
        }
      };
      fetchContacts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, pageNumber, selectedTags]);

  useEffect(() => {
    const companyId = user.companyId;

    const onContactEvent = (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({ type: "UPDATE_CONTACTS", payload: data.contact });
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_CONTACT", payload: +data.contactId });
      }
    };
    socket.on(`company-${companyId}-contact`, onContactEvent);

    return () => {
      socket.off(`company-${companyId}-contact`, onContactEvent);
    };
  }, [socket, user.companyId]);

  const handleSelectTicket = (ticket) => {
    const code = uuidv4();
    const { id, uuid } = ticket;
    setCurrentTicket({ id, uuid, code });
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      handleSelectTicket(ticket);
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const handleSelectedTags = (selecteds) => {
    const tags = selecteds.map((t) => t.id);
    setSelectedTags(tags);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleOpenContactModal = () => {
    setSelectedContactId(null);
    setContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setSelectedContactId(null);
    setContactModalOpen(false);
  };

  const hadleEditContact = (contactId) => {
    setSelectedContactId(contactId);
    setContactModalOpen(true);
  };

  const handleDeleteContact = async (contactId) => {
    try {
      await api.delete(`/contacts/${contactId}`);
      toast.success(i18n.t("contacts.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingContact(null);
    setSearchParam("");
    setPageNumber(1);
  };

  const handleBlockContact = async (contactId) => {
    try {
      await api.put(`/contacts/block/${contactId}`, { active: false });
      toast.success("Contato bloqueado");
    } catch (err) {
      toastError(err);
    }
    setDeletingContact(null);
    setSearchParam("");
    setPageNumber(1);
    setBlockingContact(null);
  };

  const handleUnBlockContact = async (contactId) => {
    try {
      await api.put(`/contacts/block/${contactId}`, { active: true });
      toast.success("Contato desbloqueado");
    } catch (err) {
      toastError(err);
    }
    setDeletingContact(null);
    setSearchParam("");
    setPageNumber(1);
    setUnBlockingContact(null);
  };

  const handleimportContact = async () => {
    try {
      await api.post("/contacts/import");
      history.go(0);
      setImportContacts(false);
    } catch (err) {
      toastError(err);
      setImportContacts(false);
    }
  };

  const handleimportChats = async () => {
    try {
      await api.post("/contacts/import/chats");
      history.go(0);
    } catch (err) {
      toastError(err);
    }
  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  const toggleSelectContact = (contactId) => {
    setSelectedContactsIds((prev) => {
      const newSelected = new Set(prev);
      if (newSelected.has(contactId)) {
        newSelected.delete(contactId);
      } else {
        newSelected.add(contactId);
      }
      return newSelected;
    });
  };

  const toggleSelectAll = () => {
    if (selectedContactsIds.size === contacts.length) {
      setSelectedContactsIds(new Set());
    } else {
      setSelectedContactsIds(new Set(contacts.map((c) => c.id)));
    }
  };

  const handleDeleteSelectedContacts = async () => {
    try {
      const idsToDelete = Array.from(selectedContactsIds);
      await Promise.all(idsToDelete.map((id) => api.delete(`/contacts/${id}`)));
      toast.success(i18n.t("contacts.toasts.deletedMultiple"));
      setSelectedContactsIds(new Set());
      setSearchParam("");
      setPageNumber(1);
      setConfirmDeleteSelectedOpen(false);
    } catch (err) {
      toastError(err);
    }
  };

  const getDisplayedNumber = (contact) => {
    if (contact?.lidWithoutPhone || (!contact?.isGroup && /@lid$/i.test(String(contact?.number || "")))) {
      return "Número não identificado";
    }
    if (enableLGPD && hideNum && user.profile === "user") {
      if (contact.isGroup) return contact.number;
      if (formatSerializedId(contact?.number) === null) {
        return `${contact.number.slice(0, -6)}**-**${contact?.number.slice(-2)}`;
      }
      return `${formatSerializedId(contact?.number)?.slice(0, -6)}**-**${contact?.number?.slice(-2)}`;
    }

    if (contact.isGroup) return contact.number;
    return formatSerializedId(contact?.number) || contact?.number || "—";
  };

  const getInitials = (name = "") => {
    const parts = name.trim().split(" ").filter(Boolean);
    if (parts.length === 0) return "?";
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  };

  const getChannelLabel = (channel) => {
    if (channel === "whatsapp") return "WhatsApp";
    if (channel === "instagram") return "Instagram";
    if (channel === "facebook") return "Facebook";
    return "Contato";
  };

  const selectedCount = selectedContactsIds.size;

  return (
    <MainContainer className={classes.mainContainer}>
      <div className={classes.contentWrapper} onScroll={handleScroll}>
        <NewTicketModal
          modalOpen={newTicketModalOpen}
          initialContact={contactTicket}
          onClose={(ticket) => {
            handleCloseOrOpenTicket(ticket);
          }}
        />
        <ContactModal
          open={contactModalOpen}
          onClose={handleCloseContactModal}
          aria-labelledby="form-dialog-title"
          contactId={selectedContactId}
        />
        <ConfirmationModal
          title={
            deletingContact
              ? `${i18n.t("contacts.confirmationModal.deleteTitle")} ${deletingContact.name}?`
              : blockingContact
              ? `Bloquear Contato ${blockingContact.name}?`
              : unBlockingContact
              ? `Desbloquear Contato ${unBlockingContact.name}?`
              : ImportContacts
              ? `${i18n.t("contacts.confirmationModal.importTitlte")}`
              : `${i18n.t("contactListItems.confirmationModal.importTitlte")}`
          }
          open={confirmOpen}
          onClose={setConfirmOpen}
          onConfirm={() =>
            deletingContact
              ? handleDeleteContact(deletingContact.id)
              : blockingContact
              ? handleBlockContact(blockingContact.id)
              : unBlockingContact
              ? handleUnBlockContact(unBlockingContact.id)
              : ImportContacts
              ? handleimportContact()
              : handleImportExcel()
          }
        >
          {exportContact
            ? `${i18n.t("contacts.confirmationModal.exportContact")}`
            : deletingContact
            ? `${i18n.t("contacts.confirmationModal.deleteMessage")}`
            : blockingContact
            ? `${i18n.t("contacts.confirmationModal.blockContact")}`
            : unBlockingContact
            ? `${i18n.t("contacts.confirmationModal.unblockContact")}`
            : ImportContacts
            ? `${i18n.t("contacts.confirmationModal.importMessage")}`
            : `${i18n.t("contactListItems.confirmationModal.importMessage")}`}
        </ConfirmationModal>

        <ConfirmationModal
          title={i18n.t("contacts.confirmationModal.deleteSelectedTitle")}
          open={confirmDeleteSelectedOpen}
          onClose={setConfirmDeleteSelectedOpen}
          onConfirm={handleDeleteSelectedContacts}
        >
          {i18n.t("contacts.confirmationModal.deleteSelectedMessage")}
        </ConfirmationModal>

        <ConfirmationModal
          title={i18n.t("contacts.confirmationModal.importChat")}
          open={confirmChatsOpen}
          onClose={setConfirmChatsOpen}
          onConfirm={() => handleimportChats()}
        >
          {i18n.t("contacts.confirmationModal.wantImport")}
        </ConfirmationModal>

        {importContactModalOpen && (
          <ContactImportWpModal
            isOpen={importContactModalOpen}
            handleClose={() => setImportContactModalOpen(false)}
            selectedTags={selectedTags}
            hideNum={hideNum}
            userProfile={user.profile}
          />
        )}

        <Paper className={classes.heroCard} elevation={0}>
          <div className={classes.heroTop}>
            <div className={classes.titleBlock}>
              <div className={classes.pageTitleRow}>
                <Typography variant="h4" className={classes.pageTitle}>
                  {i18n.t("contacts.title")}
                </Typography>
                <Chip
                  className={classes.countBadge}
                  label={`${contacts.length} contatos`}
                />
              </div>
              <Typography variant="body1" className={classes.pageSubtitle}>
                Gerencie seus contatos e conexões.
              </Typography>
            </div>


          </div>
        </Paper>

        <Paper className={classes.filtersCard} elevation={0}>
          <div className={classes.filtersGrid}>
            <div className={classes.searchWrapper}>
            <TextField
              className={classes.searchField}
              variant="outlined"
              placeholder={i18n.t("contacts.searchPlaceholder")}
              type="search"
              fullWidth
              value={searchParam}
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="primary" />
                  </InputAdornment>
                ),
              }}
            />
            </div>

            <div className={classes.tagsWrapper}>
              <TagsFilter onFiltered={handleSelectedTags} />
            </div>

          <div className={classes.actionsRow}>
            <div className={classes.actionsLeft}>
              <Button
                variant="contained"
                className={`${classes.roundedButton} ${classes.addButton}`}
                onClick={handleOpenContactModal}
                startIcon={<PersonAddIcon />}
              >
                {i18n.t("contacts.buttons.add")}
              </Button>

              <PopupState variant="popover" popupId="contacts-import-export-menu">
                {(popupState) => (
                  <>
                    <Button
                      variant="contained"
                      className={`${classes.roundedButton} ${classes.secondaryButton}`}
                      {...bindTrigger(popupState)}
                    >
                      Importar / Exportar
                      <ArrowDropDown />
                    </Button>
                    <Menu {...bindMenu(popupState)}>
                      <MenuItem
                        onClick={() => {
                          setConfirmOpen(true);
                          setImportContacts(true);
                          popupState.close();
                        }}
                      >
                        <ContactPhone
                          fontSize="small"
                          color="primary"
                          style={{ marginRight: 10 }}
                        />
                        {i18n.t("contacts.menu.importYourPhone")}
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          setImportContactModalOpen(true);
                          popupState.close();
                        }}
                      >
                        <Backup
                          fontSize="small"
                          color="primary"
                          style={{ marginRight: 10 }}
                        />
                        {i18n.t("contacts.menu.importToExcel")}
                      </MenuItem>
                    </Menu>
                  </>
                )}
              </PopupState>

              <Button
                variant="contained"
                className={`${classes.roundedButton} ${classes.deleteButton} ${selectedCount > 0 ? classes.deleteSelectedActive : ""}`}
                disabled={selectedCount === 0}
                onClick={() => setConfirmDeleteSelectedOpen(true)}
                startIcon={<DeleteSweepIcon />}
              >
                {i18n.t("contacts.buttons.deleteSelected")}
              </Button>
            </div>

          </div>
          <Typography className={classes.selectedInfo}>
            {selectedCount} selecionado{selectedCount === 1 ? "" : "s"}
          </Typography>
          </div>
        </Paper>

        <Paper className={classes.tablePaper} elevation={0}>
          <div className={classes.tableScroller}>
            <>
              <input
                style={{ display: "none" }}
                id="upload"
                name="file"
                type="file"
                accept=".xls,.xlsx"
                onChange={() => {
                  setConfirmOpen(true);
                }}
                ref={fileUploadRef}
              />
            </>

            <Table stickyHeader size="small" className={classes.tableRoot}>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox" className={classes.headerCell}>
                    <Checkbox
                      indeterminate={selectedCount > 0 && selectedCount < contacts.length}
                      checked={contacts.length > 0 && selectedCount === contacts.length}
                      onChange={toggleSelectAll}
                      inputProps={{ "aria-label": "select all contacts" }}
                    />
                  </TableCell>
                  <TableCell className={classes.headerCell}>Contato</TableCell>
                  <TableCell className={classes.headerCell} align="left">Telefone</TableCell>
                  <TableCell className={classes.headerCell} align="left">E-mail</TableCell>
                  <TableCell className={classes.headerCell} align="left">Conexão</TableCell>
                  <TableCell className={classes.headerCell} align="center">Status</TableCell>
                  <TableCell className={classes.headerCell} align="center">Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {contacts.map((contact) => (
                  <TableRow key={contact.id} hover className={classes.row}>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedContactsIds.has(contact.id)}
                        onChange={() => toggleSelectContact(contact.id)}
                        inputProps={{ "aria-label": `select contact ${contact.name}` }}
                      />
                    </TableCell>

                    <TableCell>
                      <div className={classes.contactCell}>
                        <Avatar
                          src={contact?.urlPicture || contact?.profilePicUrl || "/nopicture.png"}
                          alt={contact?.name || "avatar_contato"}
                          className={classes.avatar}
                        >
                          <Person />
                        </Avatar>
                        <div className={classes.contactInfo}>
                          <Typography className={classes.contactName}>
                            {contact.name || "Sem nome"}
                          </Typography>
                          <Typography className={classes.contactMeta}>
                            {getChannelLabel(contact.channel)}
                          </Typography>
                        </div>
                      </div>
                    </TableCell>

                    <TableCell>
                      <Typography variant="body2">{getDisplayedNumber(contact)}</Typography>
                    </TableCell>

                    <TableCell>
                      <Typography variant="body2" className={contact.email ? "" : classes.mutedText}>
                        {contact.email || "—"}
                      </Typography>
                    </TableCell>

                    <TableCell>
                      <Box display="flex" alignItems="center" gridGap={8}>
                        <Typography variant="body2" className={(contact?.connectionNames?.length || contact?.whatsapp?.name) ? "" : classes.mutedText}>
                          {contact?.connectionNames?.length
                            ? contact.connectionNames.join(" · ")
                            : (contact?.whatsapp?.name || "Sem conexão")}
                        </Typography>
                      </Box>
                    </TableCell>

                    <TableCell align="center">
                      <Chip
                        size="small"
                        className={`${classes.statusChip} ${contact.active ? classes.statusActive : classes.statusInactive}`}
                        label={contact.active ? "Ativo" : "Bloqueado"}
                        icon={contact.active ? <CheckCircleIcon style={{ color: '#18864b' }} /> : <CancelIcon style={{ color: '#cf3d3d' }} />}
                      />
                    </TableCell>

                    <TableCell align="center" className={classes.actionsCell}>
                      <Tooltip title="Abrir atendimento">
                        <span>
                          <IconButton
                            size="small"
                            className={classes.iconButton}
                            disabled={!contact.active}
                            onClick={() => {
                              setContactTicket(contact);
                              setNewTicketModalOpen(true);
                            }}
                          >
                            {contact.channel === "whatsapp" && (
                              <WhatsApp style={{ color: "green" }} />
                            )}
                            {contact.channel === "instagram" && (
                              <Instagram style={{ color: "purple" }} />
                            )}
                            {contact.channel === "facebook" && (
                              <Facebook style={{ color: "blue" }} />
                            )}
                          </IconButton>
                        </span>
                      </Tooltip>

                      <Tooltip title="Editar contato">
                        <IconButton
                          size="small"
                          className={classes.iconButton}
                          onClick={() => hadleEditContact(contact.id)}
                        >
                          <EditIcon color="secondary" />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title={contact.active ? "Bloquear contato" : "Desbloquear contato"}>
                        <IconButton
                          size="small"
                          className={classes.iconButton}
                          onClick={
                            contact.active
                              ? () => {
                                  setConfirmOpen(true);
                                  setBlockingContact(contact);
                                }
                              : () => {
                                  setConfirmOpen(true);
                                  setUnBlockingContact(contact);
                                }
                          }
                        >
                          {contact.active ? (
                            <BlockIcon color="secondary" />
                          ) : (
                            <CheckCircleIcon color="secondary" />
                          )}
                        </IconButton>
                      </Tooltip>

                      <Can
                        role={user.profile}
                        perform="contacts-page:deleteContact"
                        yes={() => (
                          <Tooltip title="Excluir contato">
                            <IconButton
                              size="small"
                              className={classes.iconButton}
                              onClick={() => {
                                setConfirmOpen(true);
                                setDeletingContact(contact);
                              }}
                            >
                              <DeleteOutlineIcon color="secondary" />
                            </IconButton>
                          </Tooltip>
                        )}
                      />
                    </TableCell>
                  </TableRow>
                ))}

                {loading && <TableRowSkeleton avatar columns={7} />}
              </TableBody>
            </Table>
          </div>
        </Paper>
      </div>
    </MainContainer>
  );
};

export default Contacts;
